import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContact } from 'services/ContactService'

export const useContactQuery = (id: string) => {
  return useQuery({
    queryKey: reactQueryKeys.contact(id),
    queryFn: () => getContact(id),
    enabled: !!id,
  })
}
